
    const html = "<div class=row> <div class=col-md-12> <div ui-view></div> </div> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/users/views/profile/profile-view-references.client.view.html', html);
    }]);
    module.exports = '/modules/users/views/profile/profile-view-references.client.view.html';
  